<template>
  <div class="main">
    <div class="content">
      <!-- 头部 -->
      <div class="herder">
        <div class="logo">
          <img src="../assets/images/logo.png" alt="">
        </div>
        <div class="introduce" @click="goIntro">
          <img src="../assets/images/introduce-icon.png" alt="">
        </div>
      </div>
      <!-- 内容 -->
      <div class="cover">
        <!-- <img width="100%" src="../assets/images/index.jpg" alt=""> -->
      </div>
      <!-- 按钮 -->
      <div class="button" @click="start">
        我的梦想
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgHeight: 0
    }
  },
  methods: {
    goIntro: function () {
      this.$router.push({path: '/introduce'});
    },
    start: function () {
      this.$router.push({path: '/info'});
    }
  },
  created() {
    // alert(document.body.scrollHeight)
    // this.bgHeight = window.screen.availHeight;
  },
  mountend () {
    // this.bgHeight = window.screen.availHeight;
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  background: url('../assets/images/index-bg.jpg') no-repeat;
  background-size: cover;
  background-position: center 40%;
  position: relative;
}
.content {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.herder {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.5rem 0 0.3rem;
  position: absolute;
  top: 5%;
}
.logo {
  width: 2.78rem;
}
.logo img {
  width: 100%;
}
.introduce {
  width: 0.96rem;
}
.introduce img {
  width: 100%;
}
.cover {
  height: 7.74rem;
}
.button {
  width: 5.9rem;
  height: 1.3rem;
  color: #fff;
  font-size: 0.46rem;
  text-align: center;
  line-height: 1.3rem;
  margin: 0 auto;
  background: url('../assets/images/pink-button.png') no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
}
</style>